import QuizScreenSaverPage from '../../components/pages/QuizScreenSaverPage';
import themes from '../../themes';

export default function QuizScreenSaver() {
  return <QuizScreenSaverPage station={'quiz'} theme={themes.quiz} />;
}
